/**
 * Lista canónica de módulos del sistema.
 * Fuente de verdad para: Ocultar Módulos, Permisos por Rol, Sidebar y rutas protegidas.
 *
 * Al agregar un módulo nuevo visible o navegable, registrarlo aquí primero.
 */
export const AVAILABLE_MODULES = [
  // General (quick access)
  { path: '/inicio', label: 'Inicio', group: 'General' },
  { path: '/extensions-directory', label: 'Directorio', group: 'General' },
  { path: '/chat', label: 'Chat', group: 'General' },
  { path: '/notificaciones', label: 'Notificaciones', group: 'General' },
  // Herramientas
  { path: '/documentos', label: 'Documentos', group: 'Herramientas' },
  { path: '/reserva-salas', label: 'Reserva de Salas', group: 'Herramientas' },
  { path: '/solicitud-taxi', label: 'Solicitud de Taxi', group: 'Herramientas' },
  { path: '/solicitud-hospedaje', label: 'Solicitud de Hospedaje', group: 'Herramientas' },
  { path: '/solicitud-viaticos', label: 'Solicitud de Viáticos', group: 'Herramientas' },
  { path: '/calendario-cierre', label: 'Calendario de Cierre', group: 'Herramientas' },
  { path: '/productos-sura', label: 'Productos SURA', group: 'Herramientas' },
  { path: '/solicitud-comida', label: 'Solicitud de Comida (CDN)', group: 'Herramientas' },
  { path: '/grabacion-reuniones', label: 'Minutas Inteligentes', group: 'Herramientas' },
  { path: '/proyectos', label: 'Proyectos', group: 'Herramientas' },
  { path: '/estacionamiento', label: 'Estacionamiento (CA1)', group: 'Herramientas' },
  // Gestión Humana
  { path: '/empleados', label: 'Empleados', group: 'Gestión Humana' },
  { path: '/vacantes', label: 'Vacantes', group: 'Gestión Humana' },
  { path: '/organigrama', label: 'Estructura Organizativa', group: 'Gestión Humana' },
  { path: '/asistencia', label: 'Asistencia', group: 'Gestión Humana' },
  { path: '/constancia-trabajo', label: 'Constancia de Trabajo', group: 'Gestión Humana' },
  { path: '/solicitud-permisos', label: 'Solicitud de Permiso', group: 'Gestión Humana' },
  { path: '/solicitud-vacaciones', label: 'Solicitud de Vacaciones', group: 'Gestión Humana' },
  // Tecnología
  { path: '/soporte-ti', label: 'Tickets', group: 'Tecnología' },
  { path: '/equipos', label: 'Equipos', group: 'Tecnología' },
  { path: '/smartphones', label: 'Smartphones', group: 'Tecnología' },
  { path: '/tablets', label: 'Tablets', group: 'Tecnología' },
  { path: '/impresoras', label: 'Impresoras', group: 'Tecnología' },
  { path: '/servidores', label: 'Servidores', group: 'Tecnología' },
  { path: '/redes', label: 'Redes', group: 'Tecnología' },
  { path: '/eventos', label: 'Eventos', group: 'Tecnología' },
  { path: '/credenciales', label: 'Credenciales', group: 'Tecnología' },
  { path: '/mantenimientos', label: 'Mantenimientos', group: 'Tecnología' },
  { path: '/presupuestos', label: 'Presupuestos', group: 'Tecnología' },
  // Seguridad y PCP
  { path: '/talleres-cursos', label: 'Talleres y Cursos', group: 'Seguridad y PCP' },
  { path: '/puertas', label: 'Puertas', group: 'Seguridad y PCP' },
  // Mercadeo
  { path: '/encuestas-producto', label: 'Encuesta de Productos', group: 'Mercadeo' },
  { path: '/academia-sura', label: 'Academia SURA', group: 'Mercadeo' },
  // Servicios Generales
  { path: '/solicitud-servicio', label: 'Solicitud de Servicio', group: 'Servicios Generales' },
  { path: '/bitacora', label: 'Bitácora', group: 'Servicios Generales' },
  { path: '/equipos-moviles', label: 'Equipos Móviles', group: 'Servicios Generales' },
  // Procura
  { path: '/requisicion-compras', label: 'Requisición a Compras', group: 'Procura' },
  { path: '/solicitud-papeleria', label: 'Solicitud de Papelería', group: 'Procura' },
  // Calidad
  { path: '/sura-reporta', label: 'Sura Reporta', group: 'Calidad' },
];

/**
 * Permisos sobre acciones dentro de un módulo, no módulos: se dan por rol en Ajustes →
 * Permisos por rol, junto a su grupo, y el backend los revisa con la misma regla
 * (admin y ti siempre los tienen). No salen en Ocultar módulos ni en el sidebar.
 */
export const PERMISOS_ACCIONES = [
  { path: '/puertas/gestion', label: 'Puertas: personas, tarjetas y huellas', group: 'Seguridad y PCP', accion: true },
];

export const PRIVILEGED_ROLES = ['admin', 'ti'];

export const NOT_IMPLEMENTED_MODULE_PATHS = [
  '/solicitud-hospedaje',
  '/academia-sura',
  '/solicitud-comida',
];

export const CONFIGURABLE_ROLES = [
  { value: 'gh', label: 'Gestión Humana' },
  { value: 'captacion', label: 'GH Captación' },
  { value: 'recepcion', label: 'Recepción' },
  { value: 'cxp', label: 'Cuentas por Pagar' },
  { value: 'costos', label: 'Costos' },
  { value: 'finanzas', label: 'Finanzas' },
  { value: 'mercadeo', label: 'Mercadeo' },
  { value: 'contabilidad', label: 'Contabilidad' },
  { value: 'procura', label: 'Procura' },
  { value: 'seguridad', label: 'Seguridad y PCP' },
  { value: 'generales', label: 'Servicios Generales' },
  { value: 'user', label: 'Usuario' },
];

const COMMON_PATHS = [
  '/inicio',
  '/extensions-directory',
  '/proyectos',
  '/chat',
  '/notificaciones',
  '/documentos',
  '/reserva-salas',
  '/estacionamiento',
  '/solicitud-taxi',
  '/solicitud-viaticos',
  '/calendario-cierre',
  '/productos-sura',
  '/encuestas-producto',
  '/organigrama',
  '/constancia-trabajo',
  '/solicitud-permisos',
  '/solicitud-vacaciones',
  '/solicitud-servicio',
  '/grabacion-reuniones',
  '/soporte-ti',
  '/sura-reporta',
];

export const DEFAULT_ROLE_PERMISSIONS = {
  gh: [...COMMON_PATHS, '/empleados', '/vacantes'],
  captacion: [...COMMON_PATHS, '/empleados', '/vacantes'],
  user: [...COMMON_PATHS],
  recepcion: [...COMMON_PATHS],
  costos: [...COMMON_PATHS, '/productos-sura'],
  cxp: [...COMMON_PATHS, '/solicitud-viaticos'],
  finanzas: [...COMMON_PATHS, '/solicitud-viaticos'],
  mercadeo: [...COMMON_PATHS, '/encuestas-producto', '/academia-sura'],
  contabilidad: [...COMMON_PATHS, '/calendario-cierre'],
  procura: [...COMMON_PATHS, '/requisicion-compras', '/solicitud-papeleria'],
  seguridad: [...COMMON_PATHS, '/talleres-cursos'],
  generales: [...COMMON_PATHS, '/bitacora', '/equipos-moviles'],
};

export const isPrivilegedRole = (role) => PRIVILEGED_ROLES.includes(role);

// Módulos que TI no ve aunque sea rol privilegiado.
export const RUTAS_SIN_TI = ['/asistencia'];

export const rolExcluido = (role, path) =>
  role === 'ti' && RUTAS_SIN_TI.some((ruta) => path === ruta || path?.startsWith(`${ruta}/`));

export const normalizeModulePath = (path) => {
  if (!path) return path;
  const cleanPath = path.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
  const exactMatch = AVAILABLE_MODULES.find(mod => mod.path === cleanPath);
  if (exactMatch) return exactMatch.path;

  const parentMatch = AVAILABLE_MODULES
    .filter(mod => cleanPath.startsWith(`${mod.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];

  return parentMatch ? parentMatch.path : cleanPath;
};

export const isModuleImplemented = (path) => {
  const normalizedPath = normalizeModulePath(path);
  return !NOT_IMPLEMENTED_MODULE_PATHS.includes(normalizedPath);
};

/**
 * Mapeo de ruta a nombre legible (para el componente ComingSoon).
 */
export const getModuleName = (path) => {
  const mod = AVAILABLE_MODULES.find(m => m.path === normalizeModulePath(path));
  return mod ? mod.label : null;
};
